import React, { FunctionComponent } from 'react';
import cls from '../utils/classnames';
import { Button } from 'packages/components';
import { SELECTOR_BUTTON, GROUP_ERROR } from '../utils/classes';
import { Tooltip, TooltipVariant } from '../Tooltip';
import { IListItem, List } from '../List';
import './_styles.scss';

export interface ISelectorProps {
    type: string;
    onClick: () => void;
    error?: boolean;
    errorFromBackend?: string;
    className?: string;
    id?: string;
    onFocus?: () => void;
}

const tooltipElement = (message: string): JSX.Element => {
    const variant = 'error';
    const checkList: IListItem[] = [];
    checkList.push({
        text: message ? message : 'Debes completar este campo para continuar.',
        variant: variant
    });
    return (
        <Tooltip
            variant={variant as TooltipVariant}
        >
        <List variant={variant} items={checkList} />
    </Tooltip>    );
}

export const SelectorButton: FunctionComponent<ISelectorProps> = props => {
    const {type, onClick, children, error = false, errorFromBackend = '', className, onFocus, id} = props;
    const tooltip = errorFromBackend ? tooltipElement(errorFromBackend) : ''
    return (
        <Button
            id={id}
            type="button"
            className={cls(
                'focusable',
                className,
                `${SELECTOR_BUTTON}-${type}`,{
                    [`${GROUP_ERROR}`]: (errorFromBackend !== '' || error)
                },
                className
            )}
            onClick={onClick}
            onFocus={onFocus}
            block
        >
            {children}
            {tooltip}
        </Button>
    );
}



// WEBPACK FOOTER //
// ./src/packages/components/lib/SelectorButton/index.tsx